module.exports = __webpack_public_path__ + "img/vehicle-options-black-hyundai.17bb0b15.png";